import { render, staticRenderFns } from "./priSettingsPage.vue?vue&type=template&id=15e1750a&scoped=true"
import script from "./priSettingsPage.vue?vue&type=script&lang=js"
export * from "./priSettingsPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15e1750a",
  null
  
)

export default component.exports